import React from "react";
import styled from "styled-components";
import Color from "color";
import { Typography, useTheme, Icon } from "@material-ui/core";

export const SubHeading = ({ children, icon }) => {
  const { palette } = useTheme();
  return (
    <Container borderColour={Color(palette.text.primary).fade(0.8).string()}>
      {icon && <Icon icon={icon} />}
      <Label>{children}</Label>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${(props) => props.borderColour};
  margin-bottom: 1.5rem;
`;
const Label = styled(Typography)`
  padding: 1rem;
  font-size: 2rem;
  font-weight: 700;
`;

// const Icon = styled(Icon)`
//   margin-left: 1rem;
// `;
